import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { AiOutlineClose } from "react-icons/ai";

const SessionTimeoutModal = ({ isOpen, secondsLeft, onStayLoggedIn, onLogoutNow }) => {
    const stopPropagation = (event) => event.stopPropagation();

    return (
        <Modal
            isOpen={isOpen}
            className="session-timeout"
            contentClassName="session-timeout__content"
            backdrop="static"
            keyboard={false}
        >
            <ModalHeader className="header">
                <AiOutlineClose
                    className="header__close-button"
                    onMouseDown={stopPropagation}
                    onClick={(event) => {
                        stopPropagation(event);
                        onStayLoggedIn();
                    }}
                />
            </ModalHeader>
            <ModalBody className="body">
                <div className="body__title">Session Expiring</div>
                <div className="body__description">
                    You have been inactive. Your session will expire in{" "}
                    <b>
                        {secondsLeft} second{secondsLeft === 1 ? "" : "s"}
                    </b>
                    .
                </div>
            </ModalBody>
            <ModalFooter className="footer">
                <div
                    className="footer__left"
                    onMouseDown={stopPropagation}
                    onClick={(event) => {
                        stopPropagation(event);
                        onLogoutNow();
                    }}
                >
                    Log Out
                </div>
                <div
                    className="footer__right"
                    onMouseDown={stopPropagation}
                    onClick={(event) => {
                        stopPropagation(event);
                        onStayLoggedIn();
                    }}
                >
                    Stay Logged In
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default SessionTimeoutModal;
